import React, {useMemo} from 'react';
import {SemVer, ShellVersion} from '~/entities/versions';
import {isIOS, isMobileApp} from '~/shared/utils/mobileDeviceDetect';
import {embeddedVersion} from '../model/AppAutoUpdater';

export function VersionDisplay() {
    const shellVersion = useMemo(ShellVersion.getFromWindow, []);

    let text: string;
    if (isMobileApp() && shellVersion) {
        const os = isIOS() ? 'iOS' : 'Android';
        text = `${os} ${ShellVersion.format(shellVersion)} (Web ${SemVer.format(embeddedVersion)})`;
    } else {
        text = `Web ${SemVer.format(embeddedVersion)}`;
    }
    return <div className='fv-text-l-regular text-center text-neutral-60'>{text}</div>;
}
